export const openDB = () => {
	return new Promise<IDBDatabase>((resolve, reject) => {
		const request = indexedDB.open('appPreferences', 1);

		request.onupgradeneeded = (event) => {
			const db = (event.target as IDBOpenDBRequest).result;
			if (!db.objectStoreNames.contains('tutorial')) {
				db.createObjectStore('tutorial', { keyPath: 'userId' });
			}
		};

		request.onsuccess = () => resolve(request.result);
		request.onerror = () => reject(request.error);
	});
};

export const setPreference = async (userId: string, viewed: boolean) => {
	const db = await openDB();
	return new Promise<void>((resolve, reject) => {
		const tx = db.transaction('tutorial', 'readwrite');
		tx.objectStore('tutorial').put({ userId, viewed });
		tx.oncomplete = () => resolve();
		tx.onerror = () => reject(tx.error);
	});
};

export const getPreference = async (userId: string) => {
	const db = await openDB();
	return new Promise<boolean>((resolve, reject) => {
		const tx = db.transaction('tutorial', 'readonly');
		const request = tx.objectStore('tutorial').get(userId);
		request.onsuccess = () => resolve(request.result?.viewed ?? false);
		request.onerror = () => reject(request.error);
	});
};
